<template>
  <div>
    <Modal content-class="sponsor-modal">
      <template #activator="{ onClick }">
        <CardSponsor
          button
          :title="sponsor.name"
          :subtitle="$t('donate.doubles_donations-2')"
          @click="onClick"
        />
      </template>
      <template #content="{ close }">
        <div class="sponsor-modal__inner">
          <div class="sponsor-modal__image">
            <img :src="sponsor?.avatar?.data || projectDefaultCover" />
          </div>
          <p class="sponsor-modal__title">{{ sponsor.name }}</p>
          <p class="sponsor-modal__content">
            {{ sponsor.description }}
          </p>
          <CardSponsor :title="$t('donate.sponsor_text')" />

          <UiButton
            color="secondary"
            class="sponsor-modal__button"
            @click="close"
          >
            {{ $t('button.good') }}
          </UiButton>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script setup>
import projectDefaultCover from '~/assets/images/project/projectDefaultCover.jpg';

defineProps({
  sponsor: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style lang="scss">
@use '@styles/components/pages/project/sponsorModal.scss' as *;
</style>
